<template>
  <div class="">
    <Loader v-if="loading" />
    <Toast :title="message" :error="error" :showToast="showToast" />
    <div class="card">
      <Section title="اطلاعات کد تخفیف">
        <div class="my-3">
          <BaseText :maxlength="2000" :value="model.title" @input="model.title = $event" title="نام کمپین" placeholder="نام کمپین" />
        </div>
        <div class="my-3">
          <BaseText
            required
            :disable="update"
            :showError="showError"
            :errortext="codeErrorText"
            :maxlength="2000"
            :value="model.code"
            @input="model.code = $event"
            title="کد تخفیف"
            placeholder="کد تخفیف"
          />
        </div>
        <div class="my-3">
          <DateTimeOffset
            range
            :error="showDateError"
            errorText="لطفا تاریخ را وارد کنید"
            :value="dateRange"
            @input="dateRange = $event"
            title="تاریخ"
            placeholder="تاریخ"
            :hasDefaultDate="false"
            :key="dateRender"
            required
          />
        </div>
        <div>
          <CountInput inputType="number" :value="model.capacity" @input="model.capacity = $event" title="ظرفیت" placeholder="ظرفیت" />
        </div>
        <div class="d-flex justify-content-between my-3">
          <div class="part">
            <div class="w-100">
              <ComboBox
                :searchedData="discountTypes"
                title="نحوه اعمال تخفیف"
                placeholder="نحوه اعمال تخفیف"
                errortext="فیلد نحوه اعمال تخفیف الزامی است."
                :selectedValue="selectedDiscountType"
                @select="fillSelectedDiscountType"
                required
                :showError="showTypeError"
                :inputStyle="comboStyle"
              />
            </div>
          </div>
          <div class="w-50 ms-4">
            <BaseText
              v-if="model.type === 0"
              inputType="number"
              :maxlength="2000"
              :value="model.percent"
              @input="model.percent = $event"
              title="میزان درصد"
              placeholder="میزان درصد"
            />
            <BaseText v-else :maxlength="2000" :value="model.amount" @input="model.amount = $event" title="مبلغ" placeholder="مبلغ" />
          </div>
        </div>
        <div class="d-flex justify-content-between my-3">
          <div class="part">
            <div class="w-100">
              <BaseText
                :disable="selectedDiscountType === 'مبلغ تخفیف'"
                :maxlength="2000"
                :value="model.upTo"
                @input="model.upTo = $event"
                title="تا سقف (تومان)"
                placeholder="تا سقف"
              />
            </div>
          </div>
          <div class="w-50 ms-4">
            <BaseText :maxlength="2000" inputType="number" :value="model.userCapacity" @input="model.userCapacity = $event" title="تعداد" placeholder="تعداد" />
          </div>
        </div>
        <div class="d-flex">
          <b-form-checkbox v-model="model.applyAfterGeneralDiscount" class="pt-2 me-3">
            <div class="mx-1">اعمال کد تخفیف بعد از تخفیف عمومی</div>
          </b-form-checkbox>
          <b-form-checkbox v-model="applyBeforGeneralDiscount" class="pt-2">
            <div class="mx-1">اعمال کد تخفیف قبل از تخفیف عمومی</div>
          </b-form-checkbox>
        </div>
        <div>
          <b-form-checkbox v-model="isDeactive" @change="setIsEnable" class="pt-2">
            <div class="mx-1">غیرفعال کردن کد تخفیف</div>
          </b-form-checkbox>
        </div>
        <b-form-checkbox v-model="model.selectAll" class="pt-2">
          <div class="mx-1">اعمال روی همه دوره ها و بسته ها</div>
        </b-form-checkbox>

        <b-form-checkbox v-model="checkSpecifiedUser" class="pt-2">
          <div class="mx-1">اعمال روی همه ی کاربران</div>
        </b-form-checkbox>
      </Section>
    </div>

    <div v-if="!model.selectAll && packagesAndCoursesTable" class="card p-3">
      <List @selected="(e) => (model.discountProducts = e)" :checkedList="model.discountProducts" :key="dateRender" />
    </div>
    <div v-if="!checkSpecifiedUser" class="card p-3">
      <div class="">
        <h5 class="my-3">کاربران اسکیل آپ</h5>
        <input v-click-outside="closeList" placeholder="جستجو" v-model="searchQuery" class="tableSearchInput" @input="updateSearchQuery(searchQuery)" @click="updateSearchQuery" />

        <div v-if="showUserList" class="scroll">
          <div class="user-list">
            <div class="d-flex position-relative item" v-for="(item, index) in list" :key="index" @click="addSelectedUser(item)">
              <div class="user-image">
                <img v-if="item.image" :src="item.image" />
                <img v-else src="../../../assets/images/users/default.png" />
              </div>
              <div class="user">
                <div class="name">
                  {{ item.fullName }}
                </div>
                <hr class="custom-hr" v-if="!item.fullName" />
                <div class="phone">
                  {{ item.phone }}
                </div>
                <hr v-if="!item.phone" class="custom-hr" />
                <div class="nationalCode">
                  {{ item.nationalCode }}
                </div>
                <hr v-if="!item.nationalCode" class="custom-hr" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 300px;" :style="userTable.length ? 'overflow-y: auto' : ''">
        <table class="my-4 w-100">
            <thead v-if="!fields.length && !userTable.length" class="table_head w-100">
      <th>
        <td style="width: 21%;">#</td>

        <td style="width: 21%;">نام و نام خانوادگی</td>

        <td style="width: 21%;">کد ملی</td>

        <td style="width: 21%;">تلفن</td>

        <td style="width: 21%;">تاریخ تولید</td>
      </th>
    </thead>

    <thead v-else class="table_head w-100">

        <td class="td" >#</td>

        <td class="td"  >نام و نام خانوادگی</td>
        
        <td class="td"  >کد ملی</td>

        
     
        <td class="td"  >تلفن</td>
        <td class="td">تاریخ تولید</td>

        <td class="td" ></td>

      
    </thead>

    
          <tbody v-if="!userTable.length && userLoading" style="height: 300px; overflow-y: auto; position: relative">
            <Loader style="position: absolute; top: 50%; left: 50%" />
          </tbody>

          <tbody v-else-if="!userTable.length" style="height: 300px; overflow-y: auto; position: relative" >
            <img src="../../../assets/images/exclamation-mark 1.svg" style="position: absolute; top: 40%; left: 50%" />
          </tbody>

          <tbody v-else>
            <tr v-for="(user, inx) in userTable" :key="inx">
              <td>
                {{ inx + 1 }}
              </td>

          
              <td>{{ user.fullName }}</td>

              <td>{{ user.nationalCode }}</td>

              <td>{{ user.phone }}</td>
           
              <td>{{ convertDate(user.createdDate) }}</td>

              <td><i class="far fa-times-circle" style="font-size: 23px; font-weight: 100; cursor: pointer" @click="deleteUser(user)"> </i></td>
            </tr>
          </tbody>
        </table>
      </div>
      <Pagination v-if="paginationData.totalPages > 1" :paginationData="paginationData" :dropDownListItems="dropDownListItems" @tableObj="onPaginate" />
    </div>

    <div class="card p-3 d-flex flex-row justify-content-end">
      <b-button @click="$router.push('/list/discount')">انصراف</b-button>
      <b-button variant="primary ms-2 px-5" @click="addDiscount">ثبت</b-button>
    </div>
  </div>
</template>
<script>
import BaseText from '../../common/form/formModules/BaseText.vue'
import DateTimeOffset from '../../common/form/formModules/DateTimeOffset.vue'
import Section from '../../common/form/Section.vue'
import CountInput from '../../common/form/CountInput.vue'
import ComboBox from '../../common/form/formModules/ComboBox.vue'
import List from '../../list'
import Loader from '../../widgets/loader.vue'
import skillUpDiscountProvider from '../../../services/skillUp/discount'
import Toast from '../../common/Toast.vue'
import skillUpUsersProvider from '../../../services/skillUp/user'
import moment from 'jalali-moment'
import Pagination from '../../common/table/simpleTable/Pagination.vue'

export default {
  components: { BaseText, DateTimeOffset, Section, CountInput, ComboBox, List, Loader, Toast, Pagination },
  props: {
    update: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showError: false,
      loading: false,
      message: '',
      showUserList: false,
      list: [],
      fields: [],
      paginationData: {},
      dropDownListItems: [
        { id: 1, count: 10, value: 'نمایش 10 تایی', isDefault: true },
        { id: 2, count: 20, value: 'نمایش 20 تایی', isDefault: false },
        { id: 3, count: 50, value: 'نمایش 50 تایی', isDefault: false },
      ],
      rows: [],
      userLoading: false,
      userTable: [],
      error: false,
      showToast: false,
      dateRender: true,
      showDateError: false,
      showTypeError: false,
      searchQuery: '',
      codeErrorText: '',
      checkSpecifiedUser: true,
      packagesAndCoursesTable: false,
      model: {
        title: '',
        code: '',
        selectAll: false,
        specifiedUser: true,
        startDate: '',
        endDate: '',
        capacity: '',
        type: '',
        percent: '',
        upTo: '',
        userCapacity: '',
        amount: '',
        isEnable: true,
        applyAfterGeneralDiscount: true,
        discountProducts: [],
        discountUsers: [],
      },
      discountTypes: [
        { key: 0, value: 'درصد تخفیف' },
        { key: 1, value: 'مبلغ تخفیف' },
      ],
      isDeactive: false,
      updateForm: false,
      comboStyle: 'color: #495057',
      selectedDiscountType: '',
      dateRange: [],
      applyBeforGeneralDiscount: '',
    }
  },
  watch: {
    'model.selectAll'(c) {
      if (c) {
        this.model.discountProducts = []
      }
    },
    '$route.query'(c) {
      if (Object.keys(c).length) this.userTable = []
    },
    checkSpecifiedUser(c) {
      if (c) {
        this.model.discountUsers = []
      }
    },
    applyBeforGeneralDiscount(c) {
      if (c) {
        this.model.applyAfterGeneralDiscount = false
        return false
      }
      if (!c) {
        this.model.applyAfterGeneralDiscount = true
      }
    },
    'model.applyAfterGeneralDiscount'(c) {
      if (c) {
        this.applyBeforGeneralDiscount = false
        return false
      }
      if (!c) {
        this.applyBeforGeneralDiscount = true
      }
    },
    'model.amount'(c) {
      if (c) {
        this.model.amount = this.model.amount.toString()
        this.model.amount = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    'model.upTo'(c) {
      if (c) {
        this.model.upTo = this.model.upTo.toString()
        this.model.upTo = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    dateRange(c) {
      if (c.length > 1) {
        const start = c[0]
        const end = c[1]
        this.model.startDate = start.replaceAll('/', '-') + 'T00:00:00.000Z'
        this.model.endDate = end.replaceAll('/', '-') + 'T00:00:00.000Z'
      }

      if (c.length === 1) {
        this.model.startDate = c[0].replaceAll('/', '-') + 'T00:00:00.000Z'
      }
      if (!c) {
        this.model.startDate = null
        this.model.endDate = null
      }
    },
  },
  async mounted() {
    if (this.update) {
      await this.fetchDiscount()
      await this.getProductUser()
      this.checkSpecifiedUser = !this.model.specifiedUser
    }
    setTimeout(() => {
      this.dateRender = false
    }, 3000)
    setTimeout(() => {
      this.packagesAndCoursesTable = true
    }, 1000)
  },
  methods: {
    async deleteUser(user) {
      this.userTable = this.userTable.filter((item) => item.id !== user.id);
      try {
        const req = await skillUpDiscountProvider.deleteUser({
          code: this.model.code,
          userId: user.id,
        })
        if (req.data.data.isSuccessful) {
          this.userTable = this.userTable.filter((item) => item.id !== user.id)
          if (this.$route.query.pageNumber) {
            this.$router.replace({
              name: this.$route.name,
              query: {
                pageNumber: this.rows.length === 1 ? this.$route.query.pageNumber - 1 : this.$route.query.pageNumber,
                perPage: this.$route.query.perPage,
              },
            })
          }
        }
        this.getProductUser()
      } catch (error) {
        console.log(error)
      }
    },
    onPaginate(page) {
      this.$router.push({ name: this.$route.name, query: { pageNumber: page.page, perPage: page.pageSize.count } })
      this.getProductUser()
    },
    convertDate(date) {    
     
         const formatDate = new Date(date).toLocaleDateString()
       const finalTime = moment(formatDate).locale('fa').format('YYYY/M/D')
        return finalTime
      
    },
    async getProductUser() {
      let pageNumber = this.$route.query.pageNumber ? this.$route.query.pageNumber : 1
      let pageSize = this.$route.query.perPage ? this.$route.query.perPage : 10

      try {
        this.userLoading = true
        const req = await skillUpDiscountProvider.getProductUser({
          search: '',
          pageSize: pageSize,
          pageNumber: pageNumber,
          isSortAsc: true,
          fieldSearchs: [
            {
              fieldName: 'Code',
              type: 'string',
              text: this.model.code,
            },
          ],
        })
        this.userLoading = false
        this.fields = req.data.data.fields
        this.rows = req.data.data.rows
        this.paginationData = req.data.pagination
        this.rows.forEach((row) => {
          row.items.push({
            color: null,
            fieldName: 'DeleteRow',
            id: null,
            size: 5,
            type: 'Delete',
            typeEnum: 0,
            value: '',
          })
        })
        this.fields.push({ index: 7, isCollection: false, key: 'DeleteRow', label: '', order: -2147483647, size: 5, statusColors: [], type: 'DeleteRow', typeEnum: 0 })

        this.makeUserTable()
      } finally {
        this.userLoading = false
      }
    },
    makeUserTable() {
      let user
      if (this.rows.length) {
        const findItem = (array, fieldName) => {
          return array.find((item) => item.fieldName === fieldName).value
        }
        this.rows.forEach((row) => {
          const FullName = findItem(row.items, 'FullName')
          const UserId = findItem(row.items, 'UserId')
          const Image = findItem(row.items, 'Image')
          const NationalCode = findItem(row.items, 'NationalCode')
          const PhoneNumber = findItem(row.items, 'PhoneNumber')
          const CreateDate = findItem(row.items, 'CreateDate')
          const DeleteRow = findItem(row.items, 'DeleteRow')
          user = {
            fullName: FullName,
            id: UserId,
            image: Image,
            nationalCode: NationalCode,
            phone: PhoneNumber,
            createdDate: CreateDate,
            deleteRow: DeleteRow,
          }

          const hasUser = this.userTable.find((item) => item.id === user.id)
          if (!hasUser) this.userTable.push(user)
        })
      }
    },
    async addSelectedUser(user) {
      if (this.$route.path === '/list/skillupdiscount/add') {
        const hasUser = this.userTable.find((item) => item.id === user.id)

        if (!hasUser) {
          this.userTable.push({...user,createdDate:new Date().toISOString( )})
          this.showToast = false
          this.$nextTick(() => {
            this.showToast = true
            this.error = false
            this.message = 'کاربر با موفقیت ثبت گردید.'
          })
        } else {
          this.showToast = false
          this.$nextTick(() => {
            this.showToast = true
            this.error = true
            this.message = 'کاربر پیش تر به لیست اضافه گردیده است .'
          })
        }
      } else if (this.rows && this.$route.path.includes('/list/skillupdiscount/detail/') ) {
        if(this.rows.length){

          const req = await skillUpDiscountProvider.addUser({
            code: this.model.code,
            userId: user.id,
          })

          if (req.data.data.isSuccessful) {
            this.showToast = false
            this.$nextTick(() => {
              this.showToast = true
              this.error = false
              this.message = 'کاربر با موفقیت ثبت گردید.'
            })
          } else {
            this.showToast = false
            this.$nextTick(() => {
              this.showToast = true
              this.error = true
              this.message = 'کاربر پیش تر به لیست اضافه گردیده است .'
            })
          }
        }else{
                const hasUser = this.userTable.find((item) => item.id === user.id)

        if (!hasUser) {
          this.userTable.push({...user,createdDate:new Date().toISOString( )})
          this.showToast = false
          this.$nextTick(() => {
            this.showToast = true
            this.error = false
            this.message = 'کاربر با موفقیت ثبت گردید.'
          })
        } else {
          this.showToast = false
          this.$nextTick(() => {
            this.showToast = true
            this.error = true
            this.message = 'کاربر پیش تر به لیست اضافه گردیده است .'
          })
        }
        }
        try {
          this.getProductUser()
        } catch (error) {
          console.log(error)
        }
      }

      this.showUserList = false
    },
    async updateSearchQuery() {
      try {
        const req = await skillUpUsersProvider.getSearchUsers(this.searchQuery ? `?keyword=${this.searchQuery || ''}&pageSize=100&pageNumber=1` : '?pageSize=100&pageNumber=1')

        this.list = req.data.data
        this.showUserList = true
      } catch (error) {
        console.log(error)
      }
    },
    setIsEnable(e) {
      if (e === true) {
        this.model.isEnable = false
        this.isDeactive = true
      } else {
        this.model.isEnable = true
        this.isDeactive = false
      }
    },
    async addDiscount() {
      this.packagesAndCoursesTable = false
      let userDiscount = []
      if (!this.dateRange.length) {
        this.showDateError = true
      } else this.showDateError = false
      if (!this.selectedDiscountType.length) {
        this.showTypeError = true
      } else this.showTypeError = false
      if (!this.model.code) {
        this.codeErrorText = 'لطفا کد تخفیف را وارد کنید'
        this.showError = true
      }  else this.showError = false

      if (this.showError || this.showDateError || this.showTypeError) {
        window.scrollTo(0, 0)
        return false
      }
      // this.loading = true
      this.model.capacity = +this.model.capacity
      this.model.userCapacity = +this.model.userCapacity
      if (this.model.capacity === 0 || !this.model.capacity) {
        this.model.capacity = null
      }
      if (this.model.userCapacity === 0 || !this.model.userCapacity) {
        this.model.userCapacity = null
      }
      if (this.model.upTo === 0 || !this.model.upTo) {
        this.model.upTo = null
      }
      if (this.model.percent === 0 || !this.model.percent) {
        this.model.percent = null
      }

      if (this.model.type === 1) {
        this.model.upTo = null
        this.model.percent = null
      }
      if (this.model.type === 0) {
        this.model.amount = null
      }

      if (this.dateRange.length === 1) {
        this.model.endDate = this.model.startDate
      }
      if (this.model.amount && typeof this.model.amount === 'string') {
        this.model.amount = this.model.amount.replace(/[^a-zA-Z0-9 ]/g, '')
        this.model.amount = +this.model.amount
      }
      if (this.model.upTo && typeof this.model.upTo === 'string') {
        this.model.upTo = this.model.upTo.replace(/[^a-zA-Z0-9 ]/g, '')
        this.model.upTo = +this.model.upTo
      }
      if (!this.checkSpecifiedUser) {
        if (this.rows.length) {
          this.rows.forEach((row) => {
            const userId = row.items.find((item) => item.fieldName === 'UserId').value
            userDiscount.push({ userId: userId })
          })
        } else {
          this.userTable.forEach((user) => userDiscount.push({ userId: user.id }))
        }
      }
      try {
        if (this.update) {
          const req = await skillUpDiscountProvider.updateDiscount({ ...this.model, specifiedUser: !this.checkSpecifiedUser, discountUsers: userDiscount })
          if (req.status === 200) {
            if (req.data.data.isSuccessful) {
              this.showError = false
              this.$emit('update', !this.updateForm)
              this.loading = false
            } else if (!req.data.data.isSuccessful) {
              this.codeErrorText = 'کد تخفیف تکراری است'
              this.showError = true
              window.scrollTo(0, 0)
            } else {
              this.showToast = false
              this.$nextTick(() => {
                this.showToast = true
                this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
                this.error = true
              })
              this.loading = false
            }
          }
          this.loading = false
          return false
        }
        const req = await skillUpDiscountProvider.addDiscount({ ...this.model, specifiedUser: !this.checkSpecifiedUser, discountUsers: userDiscount })
        if (req.status === 200) {
          if (req.data.data.isSuccessful) {
            this.showError = false
            if (req.data.data.id) {
              this.$router.push('/list/skillupdiscount/detail/' + req.data.data.id)
            } else this.$router.push('/list/skillupdiscount')
          } else if (!req.data.data.isSuccessful) {
            window.scrollTo(0, 0)
            this.codeErrorText = 'کد تخفیف تکراری است'
            this.showError = true
          } else {
            this.showToast = false
            this.$nextTick(() => {
              this.showToast = true
              this.error = true
              this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
            })
            this.loading = false
          }
        }
        this.loading = false
      } catch (error) {
        this.loading = false
        this.error = true
        this.message = 'خطایی رخ داده لطفا دوباره سعی کنید'
        this.showToast = true
        setTimeout(() => {
          this.message = ''
          this.error = true
          this.showToast = false
        }, 4000)
      }
    },
    closeList() {
      this.showUserList = false
    },
    async fetchDiscount() {
      const req = await skillUpDiscountProvider.getDiscount(this.$route.params.id)
      this.model = req.data.data.output
      if (!this.model.applyAfterGeneralDiscount) {
        this.applyBeforGeneralDiscount = true
      }
      if (this.model.startDate) {
        this.dateRange[0] = this.model.startDate.slice(0, 10).replaceAll('-', '/')
      }
      if (this.model.endDate) {
        this.dateRange[1] = this.model.endDate.slice(0, 10).replaceAll('-', '/')
      }

      this.discountTypes.filter((item) => {
        if (item.key === this.model.type) {
          this.selectedDiscountType = item.value
        }
      })
      this.setIsEnable(!this.model.isEnable)
      // this.model.upTo = await this.model.upTo.toString()
      // this.model.amount = await this.model.amount.toString()
    },
    fillSelectedDiscountType(e) {
      this.selectedDiscountType = this.discountTypes.find((item) => item.value === e).value
      this.model.type = this.discountTypes.find((item) => item.value === e).key
    },
  },
}
</script>
<style lang="scss" scoped>
.part {
  display: inline-flex;
  width: 50%;
}

.tableSearchInput {
  border: 1px solid #e8e8e8;
  box-sizing: border-box;
  border-radius: 3px;
  outline: none;
  width: 450px;
  height: 27px;
}
.tableSearchInput::placeholder {
  padding: 0 12px;
}

.user-list {
  overflow-y: auto;
  height: 170px;
}

.item {
  padding: 15px 10px;

  &:hover {
    background: rgba(85, 110, 230, 0.1);
  }
}

.user-image {
  img {
    width: 28px;
    height: 28px;
    border-radius: 100%;
  }
}

.user {
  display: flex;
  width: 100%;
  justify-content: center;
  cursor: pointer;

  .name {
    position: relative;
    top: 5px;
    margin-right: 10px;
    width: 50%;
  }

  .phone,
  .nationalCode {
    width: 25%;
    color: #999696;
    text-align: center;
    margin-right: 50px;
    position: relative;
    top: 5px;
  }
}

custom-hr {
  margin: 0 !important;
  bottom: 10px;
  position: relative;
  top: 13px;
  height: 2px;
  background-color: #000 !important;
  opacity: 0.3;
  width: 50px;
  left: 30px;
}

.scroll {
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  height: 220px;
  width: 450px;
  // padding: 10px;
  padding-left: 0;
  position: absolute;
  margin-top: 5px;
  // top: 10px;
  // right: 0;
  z-index: 100;
}

::v-deep .status {
  transform: translate(-50%, 50%);
  margin: 0;
}

.table_head {
  background-color: #f8f9fa;
  td {
    padding: 12px;
    font-size: 14px;
  }
}

.td {
  padding: 12px;
  font-size: 14px;
  font-weight: bold;
}

tbody {
  td {
    padding: 18px;
    border-bottom: 1px solid rgb(248, 239, 239);
  }
}
</style>